module.exports = __webpack_public_path__ + "img/Track.c5fbc7b5.svg";